import { useSearch } from "wouter";
import { useUser } from "@/hooks/useUser";
import { RequireAuth } from "@/components/auth/RequireAuth";
import { isPrivateCheckoutEntry } from "@/lib/checkout-entry";
import type { ReactNode } from "react";

// Only fresh, ordinary reservations have a public review step. Private offers,
// recovery sessions and existing-booking entry points retain their auth gate.
export function CheckoutEntry({ children }: { children: ReactNode }) {
  const search = useSearch();
  const { user } = useUser();
  const privateEntry = isPrivateCheckoutEntry(search, user?.id);
  return privateEntry ? <RequireAuth>{children}</RequireAuth> : <>{children}</>;
}
